// Unique Lyteflo event IDs, in syntax of element_name.action
export const EventIds = {
  OWNERSHIP_REPORT: {
    ADDRESS: "app.report.address",
    PHONE: "app.report.phone",
    EMAIL: "app.report.email",
  },
  UNSUBSCRIBE: "app.unsubscribe.cta",
};

export const AMPLITUDE_EVENTS = {
  LOGIN: "login",
  LOGIN_ERROR: "login_error",
  CLICK_NAV: "click_nav_item",
  CLICK_ADD_USER: "click_add_user",
  CLICK_VIEW_REPORT: "click_view_battery_report",
  CLICK_TRIM_SELECTOR: "click_trim_selector",
  CLICK_COPY_PUBLIC_REPORT: "click_copy_public_report_link",
  CLICK_DOWNLOAD_REPORT: "click_download_report",
  CLICK_SHARE_REPORT: "click_share_report",
  VIEW_PRIVATE_REPORT: "view_private_battery_report",
  VIEW_PUBLIC_REPORT: "view_public_battery_report",
  VIEW_OWNERSHIP_REPORT: "view_ownership_report",
  QUICK_LOOKUP_SUBMITTED: "quick_lookup_submitted",
};

export const ANALYTICS_SOURCE = {
  REPORTS_LIST: "reports_list",
  REPORT_PAGE: "report_page",
  PUBLIC_REPORT: "public_report",
  UNSCANNED_INVENTORY: "unscanned_inventory",
} as const;
export type AnalyticsSource =
  (typeof ANALYTICS_SOURCE)[keyof typeof ANALYTICS_SOURCE];

export const CERTIFICATE_TYPE = {
  FULL_PDF: "full_pdf",
  SHORT_PNG: "short_png",
} as const;
export type CertificateType =
  (typeof CERTIFICATE_TYPE)[keyof typeof CERTIFICATE_TYPE];

export const QUICK_LOOKUP_TYPE = {
  SINGLE: "single",
  BATCH: "batch",
} as const;
export type QuickLookupType =
  (typeof QUICK_LOOKUP_TYPE)[keyof typeof QUICK_LOOKUP_TYPE];

export enum AmplitudeUserProperties {
  EMAIL = "email",
  ACCOUNT_NAME = "account_name",
}

export const AMPLITUDE_LOGIN_ERROR_REASONS = {
  ERROR_OTP_VERIFICATION_FAILED: "error_otp_verification_failed",
  ERROR_GOOGLE_CALLBACK_FAILED: "error_google_callback_failed",
  ERROR_USER_DOES_NOT_EXIST: "error_user_does_not_exist",
  ERROR_UNHANDLED_AUTH_STATUS_CODE: "error_unhandled_auth_status_code",
  ERROR_UNHANDLED_AUTH_ERROR: "error_unhandled_auth_error",
};
